module.exports = __webpack_public_path__ + "static/media/warning.315034ec.svg";